// extracted by mini-css-extract-plugin
export var active = "_kr-2";
export var recordingDot = "_kr-1";
export var recordingIndicator = "_kr-0";